module.exports = __webpack_public_path__ + "img/closet.85ff483f.svg";